export function offset(el, scrollElement) {
  if (!el) {
    return
  }
  if (!scrollElement) {
    scrollElement = window
  }
  const rect = el.getBoundingClientRect()
  let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop
  if (scrollElement && scrollElement != window) {
    scrollTop = scrollElement.scrollTop
    scrollLeft = scrollElement.scrollLeft
  }
  return {
    top: rect.top + scrollTop,
    left: rect.left + scrollLeft,
    height: rect.height,
    width: rect.height,
  }
}

const isSmoothScrollSupported =
  'scrollBehavior' in document.documentElement.style

/**
 * @param {Element} el
 */
export function scrollTo(el, subtractScroll = 0, scrollEl) {
  if (!scrollEl) {
    scrollEl = window
  }
  const { top = 0 } = offset(el, scrollEl) || {}
  if (isSmoothScrollSupported) {
    // behavior:auto|smooth|initial|inherit
    scrollEl.scrollTo({ top: top - subtractScroll, left: 0, behavior: 'auto' })
  } else {
    scrollEl.scrollTo(0, top - subtractScroll)
  }
}

export const isDOMElement = (element) => {
  return typeof element.type === 'string'
}

/**
 * Extracts text content from React children elements recursively.
 * Handles strings, numbers, arrays, and React elements with props.children.
 *
 * @param {string|number|Array|Object|null|undefined} children - The children to extract text from
 * @returns {string} The extracted text content, joined with spaces for arrays
 *
 */
export const extractTextFromChildren = (children) => {
  // Early return for primitive types
  if (typeof children === 'string') return children
  if (typeof children === 'number') return children.toString()
  if (!children) return ''

  if (Array.isArray(children)) {
    return children.map(extractTextFromChildren).join(' ')
  } else if (children && typeof children === 'object' && children.props) {
    return extractTextFromChildren(children.props.children)
  }

  return ''
}
